export const SHOW_MODAL_FREE = "SHOW_MODAL_FREE";
export const HIDE_MODAL_FREE = "HIDE_MODAL_FREE";

const openModalFreeDispatch = (data) => {
    return {
        type: SHOW_MODAL_FREE, 
        data:data
    };
}

const closeModalFreeDispatch = (data) => {
    return {
        type: HIDE_MODAL_FREE, 
        data:data
    };
}


export const openModalFree = (open, typeMembership, role) => (dispatch) => {
    process_open_modal_free(dispatch, open, typeMembership, role)
}

export const closeModalFree = (open, typeMembership, role) => (dispatch) => {
    process_close_modal_free(dispatch, open, typeMembership, role)
}


function process_open_modal_free (dispatch, open, typeMembership, role){
    dispatch(openModalFreeDispatch({open, typeMembership, role}));
}

function process_close_modal_free (dispatch, open, typeMembership, role){
    dispatch(closeModalFreeDispatch({open, typeMembership, role}));
}

